var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2498 0.5C19.6295 0.5 19.9433 0.78215 19.993 1.14823L19.9998 1.25V14.2541C19.9998 14.6683 19.664 15.0041 19.2498 15.0041C18.8701 15.0041 18.5563 14.7219 18.5066 14.3558L18.4998 14.2541V1.25C18.4998 0.83579 18.8356 0.5 19.2498 0.5ZM10.6469 2.30373L10.7195 2.21961C10.9858 1.95338 11.4025 1.92921 11.6961 2.1471L11.7802 2.21972L16.7768 7.2174C17.0429 7.4835 17.0672 7.8999 16.8496 8.1935L16.7771 8.2776L11.7805 13.2811C11.4878 13.5742 11.0129 13.5745 10.7198 13.2818C10.4534 13.0157 10.4289 12.5991 10.6465 12.3053L10.7191 12.2211L14.43 8.504L0.75 8.5049C0.3703 8.5049 0.05651 8.2228 0.00685 7.8567L0 7.7549C0 7.3753 0.28215 7.0615 0.64823 7.0118L0.75 7.0049L14.443 7.004L10.7194 3.28028C10.4532 3.01398 10.429 2.59732 10.6469 2.30373Z",
    fill: "#545565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutIcon);
export default __webpack_public_path__ + "static/media/sign_out_icon.11afdc5b744d12ed062c85582d36f4c8.svg";
export { ForwardRef as ReactComponent };